// tid 版头loc-id对照字典
export const bannerIdMap = {
  1: 1576,
  13: 1612,
  167:1920,
  3: 1580,
  129: 1584,
  4: 1588,
  36: 1592,
  160: 1600,
  119: 1608,
  155: 1604,
  165: 1620,
  166: 1620,
  5: 1596,
  23: 1634,
  11: 1616,
  181: 2210,
  177: 2260,
  188: 3129,
  211: 4249,
  217: 4363,
}